import { HorizontalRule } from './horizontal-rule.js'

export * from './horizontal-rule.js'

export default HorizontalRule
